<template>
  <transition name="c-modalBenefit">
  <div v-if="isShow" class="c-modalBenefit isOpen">
    <div class="c-modalBenefit__wrap" :style="setStyleWrap()">
      <iframe v-if="isShow" width="560" height="315" :src="`https://www.youtube.com/embed/${movieID}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div class="c-modalBenefit__btn">
      <div class="c-modalBenefit__close" @click="close">
        <div class="c-modalBenefit__closeWrap">
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables';

  export default {
    data() {
      return {
        lang: '',
        ispc: false,
        adjust: {
          pc: {
            h: 170,
            w: 240
          },
          sp: {
            h: 100,
            w: 60
          }
        },
        isShow: false,
        preWidth: 0,
        styleWrap: '',
        movies: [],
        movieID: ''
      }
    },
    computed: {
      setStyleWrap: function() {
        return function() {
          return this.styleWrap;
        }
      }
    },
    created() {

    },
    mounted() {
      this.lang = this.$store.getters.getLang;

      if (this.lang === "ja") {
        this.movies[0] = 'Msnfx-HJW3I';
        this.movies[1] = 'WMbxBji1RLE';
        this.movies[2] = 'X-P-Be8Iv3s';
        this.movies[3] = 'OZMxMlL48Ak';
      } else if (this.lang === "en") {
        this.movies[0] = 'Y9u5fzSGA6Q';
        this.movies[1] = 'Klq4qlJKUOM';
        this.movies[2] = 'MvL0KopVxYg';
        this.movies[3] = 'zJ0DyKJmnjU';
      } else if (this.lang === "de") {
        this.movies[0] = 'AwyzVwQYEPU';
        this.movies[1] = 'b1l74xwYcig';
        this.movies[2] = 'g79CLd4rH2Q';
        this.movies[3] = 'iMEb30D-I_E';
      } else if (this.lang === "fr") {
        this.movies[0] = 'xy_eZ6HtD0Y';
        this.movies[1] = 'M7G4FB7qt9g';
        this.movies[2] = 'QThMmVm76dw';
        this.movies[3] = 'IvL_AweKKng';
      } else if (this.lang === "it") {
        this.movies[0] = 'm9Wp-Z533n8';
        this.movies[1] = 'hxVFwaoL_9c';
        this.movies[2] = 'wX9joGXl9Hs';
        this.movies[3] = 'jC9T9qnJaXs';
      } else if (this.lang === "es") {
        this.movies[0] = 'xSvHvRShXIc';
        this.movies[1] = 'tHIORSMLRIA';
        this.movies[2] = 'EFgy-HHCpGA';
        this.movies[3] = 'tlyTck-p_4I';
      } else if (this.lang === "zh-cmn-Hans") {
        this.movies[0] = 'ApCciFXAQTw';
        this.movies[1] = 'BJz_L4GWoxI';
        this.movies[2] = 'n98pHVume0Y';
        this.movies[3] = 'wZb5NekGLbg';
      } else if (this.lang === "zh-cmn-Hant") {
        this.movies[0] = 'rQuBM3tkVYI';
        this.movies[1] = '1Al9PoYJ2vU';
        this.movies[2] = 'AoTVkuE3vQY';
        this.movies[3] = 'z6VHF2_Ikp0';
      } else {
        this.movies[0] = 'Msnfx-HJW3I';
        this.movies[1] = 'WMbxBji1RLE';
        this.movies[2] = 'X-P-Be8Iv3s';
        this.movies[3] = 'OZMxMlL48Ak';
      }

      this.resize();
      window.addEventListener('resize', this.resize);
    },
    methods: {
      resize() {
        if (!this.isShow) return;

        let imgW = 16, imgH = 9;
        const winW = this.getBodyWidth();
        const winH = window.innerHeight;
        this.windowHeight = winH;

        let adjust = {};
        if (window.innerWidth > breakpoint) {
          this.ispc = true;
          adjust = this.adjust.pc;
        } else {
          this.ispc = false;
          adjust = this.adjust.sp;
        }

        if (this.ispc || this.preWidth !== winW) {
          // ブラウザサイズにフィット
          const bgW = winW - adjust.w;
          const bgH = winH - adjust.h;
          const scale = Math.min(bgW / imgW, bgH / imgH);
          const frameW = imgW * scale;
          const frameH = imgH * scale;
          const frameX = (bgW - frameW) / 2;
          const frameY = (bgH - frameH) / 2;

          this.styleWrap = `height:${frameH}px; width:${frameW}px`;
        }
      },
      open(num) {
        this.movieID = this.movies[num];
        this.isShow = true;
        this.resize();
      },
      close() {
        this.isShow = false;
      },
      getBodyWidth() {
        return document.body.clientWidth || window.innerWidth;
      }
    }
  }
</script>